import React, { Fragment, useState } from "react";
import { signOut } from "aws-amplify/auth";

/**
 * NoOrganizationRoles Component
 *
 * Props:
 * @param {string} firstName - User's first name
 * @param {string} email - User's email address
 * @param {function} onCancel - Callback function to return to login
 */

function NoOrganizationRoles(props) {
	const [isLoggingOut, setIsLoggingOut] = useState(false);

	const handleLogout = async () => {
		try {
			setIsLoggingOut(true);
			await signOut();
			// Call onCancel to return to login screen
			props.onCancel();
		} catch (error) {
			console.error("Error signing out:", error);
			setIsLoggingOut(false);
		}
	};

	const handleSignUpRedirect = () => {
		window.open("https://www.redawning.com/pm", "_blank");
	};

	const handleContactSupport = () => {
		const subject = `RedAwning account for ${props.email}`;
		const encodedSubject = encodeURIComponent(subject);
		window.open(
			`mailto:hostsupport@redawning.com?subject=${encodedSubject}`,
			"_blank"
		);
	};

	return (
		<Fragment>
			<div className="no-org-message">
				<p>
					Hi <strong>{props.firstName || "there"}</strong>,
				</p>

				<p>
					It looks like your profile isn't linked to a RedAwning account. If you
					feel like you should have an account set up, please reach out to our
					customer service team.
				</p>

				<p>
					If you'd like to sign up for RedAwning property management services,
					we'd be happy to help you get started.
				</p>
			</div>

			<div className="no-org-actions">
				<button
					type="button"
					className="submit-button"
					onClick={handleContactSupport}
					style={{ marginBottom: "1rem" }}>
					Contact Customer Service
				</button>

				<button
					type="button"
					className="submit-button"
					onClick={handleSignUpRedirect}
					style={{ marginBottom: "1rem" }}>
					Sign Up for Property Management
				</button>
			</div>

			<div className="form-links">
				<button
					type="button"
					className="cancel-button"
					onClick={handleLogout}
					disabled={isLoggingOut}
					style={{
						border: "none",
						background: "transparent",
						color: "#666",
						textDecoration: "underline",
						cursor: "pointer",
						fontSize: "0.9rem",
					}}>
					{isLoggingOut ? "Logging out..." : "Logout"}
				</button>
			</div>
		</Fragment>
	);
}

export default NoOrganizationRoles;
